export default `<svg
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	version="1.1"
	width="211px"
	height="101px"
	viewBox="-0.5 -0.5 211 101"
	content='&lt;mxfile host="gram.ax" modified="2024-07-18T06:51:07.562Z" agent="Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:128.0) Gecko/20100101 Firefox/128.0" etag="PmIRaG0YGf4FPfd893Q0" version="24.3.1" type="embed" scale="1" border="0"&gt;&#xA;  &lt;diagram id="0UfPkyyqbAn2JO725Rxe" name="Page-1"&gt;&#xA;    &lt;mxGraphModel dx="1814" dy="914" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" math="0" shadow="0"&gt;&#xA;      &lt;root&gt;&#xA;        &lt;mxCell id="0" /&gt;&#xA;        &lt;mxCell id="1" parent="0" /&gt;&#xA;        &lt;mxCell id="-t71Qm6tdKJA_Hh_hk4v-2" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" parent="1" source="-t71Qm6tdKJA_Hh_hk4v-1" edge="1"&gt;&#xA;          &lt;mxGeometry relative="1" as="geometry"&gt;&#xA;            &lt;mxPoint x="520" y="440" as="targetPoint" /&gt;&#xA;          &lt;/mxGeometry&gt;&#xA;        &lt;/mxCell&gt;&#xA;        &lt;mxCell id="-t71Qm6tdKJA_Hh_hk4v-5" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" parent="1" source="-t71Qm6tdKJA_Hh_hk4v-1" edge="1"&gt;&#xA;          &lt;mxGeometry relative="1" as="geometry"&gt;&#xA;            &lt;mxPoint x="520" y="500" as="targetPoint" /&gt;&#xA;          &lt;/mxGeometry&gt;&#xA;        &lt;/mxCell&gt;&#xA;        &lt;mxCell id="-t71Qm6tdKJA_Hh_hk4v-1" value="" style="rounded=1;whiteSpace=wrap;html=1;" parent="1" vertex="1"&gt;&#xA;          &lt;mxGeometry x="350" y="440" width="120" height="60" as="geometry" /&gt;&#xA;        &lt;/mxCell&gt;&#xA;        &lt;mxCell id="-t71Qm6tdKJA_Hh_hk4v-3" value="" style="rhombus;whiteSpace=wrap;html=1;" parent="1" vertex="1"&gt;&#xA;          &lt;mxGeometry x="520" y="420" width="40" height="40" as="geometry" /&gt;&#xA;        &lt;/mxCell&gt;&#xA;        &lt;mxCell id="-t71Qm6tdKJA_Hh_hk4v-6" value="" style="rhombus;whiteSpace=wrap;html=1;" parent="1" vertex="1"&gt;&#xA;          &lt;mxGeometry x="520" y="480" width="40" height="40" as="geometry" /&gt;&#xA;        &lt;/mxCell&gt;&#xA;      &lt;/root&gt;&#xA;    &lt;/mxGraphModel&gt;&#xA;  &lt;/diagram&gt;&#xA;&lt;/mxfile&gt;&#xA;'
>
	<defs />
	<g>
		<g>
			<path
				d="M 120 50 L 145 50 L 145 20.5 L 163.63 20.13"
				fill="none"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="stroke"
			/>
			<path
				d="M 168.88 20.02 L 161.95 23.66 L 163.63 20.13 L 161.81 16.66 Z"
				fill="rgb(0, 0, 0)"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="all"
			/>
		</g>
		<g>
			<path
				d="M 120 50 L 145 50 L 145 80.5 L 163.63 80.13"
				fill="none"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="stroke"
			/>
			<path
				d="M 168.88 80.02 L 161.95 83.66 L 163.63 80.13 L 161.81 76.66 Z"
				fill="rgb(0, 0, 0)"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="all"
			/>
		</g>
		<g>
			<rect
				x="0"
				y="20"
				width="120"
				height="60"
				rx="9"
				ry="9"
				fill="rgb(255, 255, 255)"
				stroke="rgb(0, 0, 0)"
				pointer-events="all"
			/>
		</g>
		<g>
			<path
				d="M 190 0 L 210 20 L 190 40 L 170 20 Z"
				fill="rgb(255, 255, 255)"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="all"
			/>
		</g>
		<g>
			<path
				d="M 190 60 L 210 80 L 190 100 L 170 80 Z"
				fill="rgb(255, 255, 255)"
				stroke="rgb(0, 0, 0)"
				stroke-miterlimit="10"
				pointer-events="all"
			/>
		</g>
	</g>
</svg>
`;
